import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Biggen } from "../directives/biggen";
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-p52',
  imports: [Biggen, Link],
  templateUrl: './p52.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './p52.scss',
})
export class P52 {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`P52`);
    this.dynamicTitle.description(`P52, also known as the Rylands Library Papyrus P52, contains a portion of the Gospel of John. It does not provide any direct information about Jesus himself.`);
  }
}
